import {
  AVALIACOES_LIST,
  AVALIACOES_READ,
  AVALIACOES_ADD,
  AVALIACOES_MODIFY,
  AVALIACOES_REMOVE,
  AVALIACOES_UPLOAD,
  AVALIACOES_ENVIAR,
  AVALIACOES_STATUS,
  AVALIACOES_RESPONDER,
  AVALIACOES_RESPONDER_FINALIZAR,
  AVALIACOES_REVISAR,
  AVALIACOES_REVISAR_FINALIZAR,
  AVALIACOES_CONCLUIR,
  AVALIACOES_RECUSAR,
  AVALIACOES_CANCELAR,
  AVALIACOES_OTP_EMITIR,
  AVALIACOES_OTP_VALIDAR
} from '../const/servicesURI';
import requestService from './requestService';
import { httpRequests } from 'investira.sdk';
import utils from '../utils';

const cancel = {
  list: null,
  read: null,
  listUpload: null
};

export const list = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.list.token
  };

  return requestService(xProps, AVALIACOES_LIST, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const read = (pAvaliacaoId, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  if (cancel.read) {
    cancel.read.cancel();
  }

  cancel.read = httpRequests.cancelToken();

  const xProps = {
    ...pRequestOptions,
    cancelToken: cancel.read.token
  };

  return requestService(xProps, `${AVALIACOES_READ}${pAvaliacaoId}`, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Read');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const listUpload = (pAvaliacaoId, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  if (cancel.listUpload) {
    cancel.listUpload.cancel();
  }

  cancel.listUpload = httpRequests.cancelToken();

  const xProps = {
    ...pRequestOptions,
    params: { avaliacao_id: pAvaliacaoId },
    cancelToken: cancel.listUpload.token
  };

  return requestService(xProps, AVALIACOES_UPLOAD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Upload List');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_ADD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Add');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'PATCH'
  };

  return requestService(xProps, AVALIACOES_MODIFY, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Modify');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pAvaliacaoId, pResolve, pReject, pFinally) => {
  const xProps = {
    data: { avaliacao_id: pAvaliacaoId },
    method: 'DELETE'
  };

  return requestService(xProps, AVALIACOES_REMOVE, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Remove');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const upload = (pData, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  const xFormData = new FormData();

  xFormData.append('avaliacao_id', pData.avaliacao_id);
  xFormData.append('documento_tipo', pData.documento_tipo);
  if (pData.avaliacao_questao_id) {
    xFormData.append('avaliacao_questao_id', pData.avaliacao_questao_id);
  }

  if (pData.entidade_id) {
    xFormData.append('entidade_id', pData.entidade_id);
  }

  const xFiles = Array.isArray(pData.files) ? pData.files : pData.files ? [pData.files] : [];
  xFiles.forEach(pFile => {
    xFormData.append('files', pFile);
  });

  const xProps = {
    ...pRequestOptions,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: xFormData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_UPLOAD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Upload');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const removeUpload = (pData, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  const xProps = {
    ...pRequestOptions,
    data: pData,
    method: 'DELETE'
  };

  return requestService(xProps, AVALIACOES_UPLOAD, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Upload Remove');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const enviar = (pAvaliacaoId, pResolve, pReject, pFinally) => {
  const xProps = {
    data: { avaliacao_id: pAvaliacaoId },
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_ENVIAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Enviar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const status = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_STATUS, 1)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Status');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const responder = (pData, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  const xProps = {
    ...pRequestOptions,
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_RESPONDER, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Responder');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const responderFinalizar = (pData, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  const xProps = {
    ...pRequestOptions,
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_RESPONDER_FINALIZAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Responder Finalizar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const revisar = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_REVISAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Revisar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const revisarFinalizar = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_REVISAR_FINALIZAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Revisar Finalizar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const concluir = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_CONCLUIR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Concluir');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const recusar = (pData, pResolve, pReject, pFinally, pRequestOptions = {}) => {
  const xProps = {
    ...pRequestOptions,
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_RECUSAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Recusar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const cancelar = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_CANCELAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes Cancelar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const otpEmitir = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_OTP_EMITIR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes OTP Emitir');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const otpValidar = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: 'POST'
  };

  return requestService(xProps, AVALIACOES_OTP_VALIDAR, 3)
    .then(rRes => {
      return pResolve && pResolve(rRes);
    })
    .catch(rErr => {
      utils.request.tracer(rErr, 'Error Service Avaliacoes OTP Validar');
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const avaliacoes = {
  list,
  read,
  listUpload,
  add,
  modify,
  remove,
  upload,
  removeUpload,
  enviar,
  status,
  responder,
  responderFinalizar,
  revisar,
  revisarFinalizar,
  recusar,
  cancelar,
  otpEmitir,
  otpValidar,
  concluir,
  cancel
};

export default avaliacoes;
